module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetypes-document-9eb1c1f9a1f29e67c9160984c10c40d9.svg";